var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box_M"},[_vm._m(0),_c('bottom-menu')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info_box_m detail"},[_c('div',{staticClass:"title"},[_vm._v("简历详情")])])}]

export { render, staticRenderFns }